import React from 'react'
import '../Common.scss'
import defaultImage from '../../../assets/default.png';

export default function FalseCeilingSectionView({pageDetails}) {
  const {images}=pageDetails
  return (
    <React.Fragment>
      <div className="page-heading">{pageDetails?.name}</div>
      {
        images && images.map((image)=>{
          return<React.Fragment>
                <div className="page-image-container" style={{height:"100%"}}>
                    <div className="image-section-container" >
                      <div>
                        <img crossOrigin="anonymous"  src={image ? image?.imageUrl : defaultImage } alt="" className="image-view" style={{marginTop:"10px"}}/>
                        <p className="image-container-heading" style={{textAlign:"center",marginTop:"-15px"}}>{image?.name ? image?.name : "AA"}</p>
                      </div>
                    </div>
                </div>
              </React.Fragment>
        })
      }
    </React.Fragment>

  )
}

